import "../styles/WhatsappSticky.css";

export default function WhatsappSticky() {
  return (
    <a
      href="https://wa.me/5493584856527"
      target="_blank"
      rel="noreferrer"
      className="whatsapp-sticky"
      aria-label="WhatsApp Malaika"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        fill="currentColor"
      >
        <path d="M19.11 17.39c-.29-.15-1.71-.84-1.97-.93-.26-.1-.45-.15-.64.15-.19.29-.74.93-.91 1.12-.17.19-.34.22-.63.07-.29-.15-1.22-.45-2.32-1.44-.86-.77-1.44-1.72-1.61-2.01-.17-.29-.02-.45.13-.6.14-.14.29-.34.44-.51.15-.17.2-.29.29-.48.1-.19.05-.36-.02-.51-.07-.15-.64-1.55-.88-2.13-.23-.55-.46-.48-.64-.49h-.55c-.19 0-.51.07-.78.36-.27.29-1.03 1-1.03 2.44s1.05 2.84 1.2 3.04c.15.19 2.07 3.17 5.01 4.44.7.3 1.25.48 1.68.61.7.22 1.34.19 1.84.12.56-.08 1.71-.7 1.95-1.37.24-.67.24-1.25.17-1.37-.07-.12-.26-.19-.55-.34z"/>
        <path d="M16 3C9.38 3 4 8.38 4 15c0 2.64.86 5.09 2.32 7.07L4 29l7.11-2.28A11.9 11.9 0 0016 27c6.62 0 12-5.38 12-12S22.62 3 16 3z"/>
      </svg>
    </a>
  );
}
